import { motion } from 'framer-motion';

const QuantumExpressionsSection = () => {
  return (
    <section className="relative py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/35fc2908723ee18ca2703b07429971f8.jpg" 
          alt="Quantum Expressions Background" 
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-purple-900/85 via-purple-800/75 to-pink-900/85"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Image */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="relative rounded-3xl overflow-hidden shadow-2xl shadow-purple-900/50">
              <img 
                src="https://static.readdy.ai/image/9910db4e977c4892bacf08542838a807/01b55664f731c104abff3b1d23dfd30d.png" 
                alt="Quantum Expressions Deck" 
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-purple-900/40 to-transparent"></div>
            </div>
            
            {/* Floating accent */}
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-cyan-400/20 rounded-full blur-3xl"></div>
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-pink-400/20 rounded-full blur-3xl"></div>
          </motion.div>

          {/* Right: Content */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="text-white"
          >
            <div className="inline-block px-4 py-2 bg-cyan-400/20 border border-cyan-400/30 rounded-full mb-6">
              <span className="text-cyan-300 text-sm font-semibold">Deepen Your Practice</span>
            </div>

            <h2 className="font-serif text-5xl md:text-6xl font-bold mb-6">
              Quantum Expressions Deck
            </h2>

            <p className="text-purple-100 text-lg mb-8 leading-relaxed">
              If you'd like to explore insights further using the Quantum Expressions Deck, discover a transformational tool for self-inquiry, alignment, and energetic clarity. This beautifully designed deck bridges digital wisdom with tactile spiritual practice.
            </p>

            <div className="space-y-4 mb-10">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-cyan-400/20 rounded-lg flex-shrink-0">
                  <i className="ri-grid-line text-xl text-cyan-400"></i>
                </div>
                <div>
                  <h3 className="font-bold text-white mb-1">72 Core Elements</h3>
                  <p className="text-purple-200 text-sm">A complete matrix mapping the full spectrum of energy across multiple scales</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-cyan-400/20 rounded-lg flex-shrink-0">
                  <i className="ri-hand-heart-line text-xl text-cyan-400"></i>
                </div>
                <div>
                  <h3 className="font-bold text-white mb-1">Tactile Spiritual Practice</h3>
                  <p className="text-purple-200 text-sm">Experience the power of physical connection with your guidance</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-cyan-400/20 rounded-lg flex-shrink-0">
                  <i className="ri-book-open-line text-xl text-cyan-400"></i>
                </div>
                <div>
                  <h3 className="font-bold text-white mb-1">Descriptive Booklet</h3>
                  <p className="text-purple-200 text-sm">Detailed explanations and spreads to enhance your readings</p>
                </div>
              </div>
            </div>

            <a
              href="https://cybernetix.com/quantumexpressions"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 px-8 py-4 bg-cyan-400 text-purple-900 font-bold rounded-xl hover:shadow-2xl hover:shadow-cyan-400/40 transition-all whitespace-nowrap cursor-pointer"
            >
              Explore the Deck
              <i className="ri-arrow-right-line text-xl"></i>
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default QuantumExpressionsSection;
